import React, { useEffect } from 'react';
import '../Assets/Additionalcss/Oatcss.css'
import oatlogo from '../Assets/Images/oat.png'

function Oatnavbar({openSidebar})  {
    
      useEffect(()=>{

        document.getElementById("usernameoat").innerHTML=localStorage.getItem('username')
        document.getElementById("oatrole").innerHTML=localStorage.getItem('RoleName')

      });
    
    return (
        <div className='OAT-navbar'>
     <div className='OAT-nav-icon' >
            <i className='fa fa-bars' onClick={openSidebar}></i>
        </div>

        <div className='OAT-navbar-left'>
        <div className='OAT-sidebar-img'>
             {/* <img src={oatlogo} alt="logo"/>&nbsp;&nbsp; */}
            
        </div>
        </div>

        <div className='OAT-navbar-right'>
            
            <a>
              
            <i class="fa fa-user-circle" aria-hidden="true"></i>
            </a>
            <div className='OAT-right-navbar'>
            <span id="usernameoat"></span>
            [<span id="oatrole"></span>]
            </div>
             
           

        </div>   
    </div>
    );
}

export default Oatnavbar;